import React from "react";

import VerifyEmailForm from "./form";
import { Link } from "react-router-dom";
import AppLogo from "components/common/Logo";
import { useMediaQuery } from "@mui/material";
import login from "assets/images/login.png";

// import VerifyEmailSvg from "assets/images/illustrations/VerifyEmail.svg";
// import AppLogo from "@/components/common/Logo";
// import { useMediaQuery } from "@mui/material";

const VerifyEmail = () => {
	const mdScreen = useMediaQuery("(min-width:767px)");

	return (
		<div className="flex items-center justify-center">
			<div className="flex flex-col md:flex-row w-full min-h-screen relative">
				<Link
					to={"/"}
					className="flex md:absolute justify-center md:top-2 md:left-4 md:ml-8 z-50 mt-2 cursor-pointer"
				>
					<AppLogo mode={mdScreen ? "light" : "dark"} />
				</Link>
				<div className="md:w-1/2 h-[320px] md:h-screen flex justify-center items-center m-5 md:m-0 bg-gray-100">
					<img src={login} alt="" className="object-cover w-full" />
				</div>
				<VerifyEmailForm />
			</div>
		</div>
	);
};

export default VerifyEmail;
